import { V2Alert, V2AlertTitle, V2LinkButton } from "@stacklet/ui";
import { graphql, useFragment } from "react-relay";

import { HelpDrawerTrigger } from "app/components/HelpDrawer/HelpDrawerTrigger";

import type { CreateNotificationRuleHeader_query$key } from "./__generated__/CreateNotificationRuleHeader_query.graphql";

interface Props {
  /** Fragment key for the root query */
  queryRef: CreateNotificationRuleHeader_query$key;
}

export function CreateNotificationRuleHeader({ queryRef }: Props) {
  const data = useFragment(
    graphql`
      fragment CreateNotificationRuleHeader_query on Query {
        jiraInstances {
          pageInfo {
            total
          }
        }
      }
    `,
    queryRef,
  );

  const hasJiraInstances = (data.jiraInstances?.pageInfo.total ?? 0) > 0;

  return (
    <>
      <div className="mb-6 flex items-center justify-between gap-2">
        <h1 className="text-title-large">
          Create notification rule for new resource matches
        </h1>
        <HelpDrawerTrigger />
      </div>
      {!hasJiraInstances ? (
        <V2Alert
          action={
            <V2LinkButton href="/settings/integrations/jira" variant="tertiary">
              Go to Jira setup
            </V2LinkButton>
          }
          className="mb-6"
          severity="warning"
        >
          <V2AlertTitle severity="warning">
            Jira Integration Missing
          </V2AlertTitle>
          Jira must be set up in Stacklet before creating a notification rule.
        </V2Alert>
      ) : null}
    </>
  );
}
